import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IContact, IDropdown } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVInputMask } from "../../shared/JVInputMask";
import { JVDropdown } from "../../shared/JVDropdown";

const schema = yup.object({
    contact_Person_Name: yup.string().required("Name is required"),
    contact_Person_Number: yup.string().required("Contact is required"),
    contact_Person_Email: yup.string().nullable().transform((value) => value === "" ? null : value).email("Please enter a valid email address").optional(),
    state_ID: yup.number().nullable().when("country_ID", { is: (val: any) => val && val > 0, then: (schema) => schema.required("State is required").min(1, "State is required"), otherwise: (schema) => schema.optional(), }),
    city_ID: yup.number().nullable().when("state_ID", { is: (val: any) => val && val > 0, then: (schema) => schema.required("City is required").min(1, "City is required"), otherwise: (schema) => schema.optional(), }),
    // contact_Person_Email: yup.string().email().required("Contact Number is required"),
    // country_ID: yup.number().required("Country is required").min(1, "Country is required"),
    // state_ID: yup.number().required("State is required").min(1, "State is required"),
    // city_ID: yup.number().required("City is required").min(1, "State is required"),
    source_ID: yup.number().required("").min(1, "Source is required"),
});

interface Iprops {
    singleData: IContact,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [submitting, setSubmitting] = useState(false);
    const [countries, setCountries] = useState<IDropdown[]>();
    const [states, setStates] = useState<IDropdown[]>();
    const [cities, setCities] = useState<IDropdown[]>();
    const [sources, setSources] = useState<IDropdown[]>();

    const { control, handleSubmit, watch, setValue, formState: { errors }, reset } = useForm<IContact>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    const countryId = watch("country_ID");
    const stateId = watch("state_ID");


    const loadCountries = async () => {
        const response = await Fetch("country/dropdown", "GET", null, null, null);
        if (response) {
            setCountries(await response.json());
        }
    }

    const loadStates = async (countryId: number) => {
        const response = await Fetch(`state/dropdown/${countryId}`, "GET", null, null, null);
        if (response) {
            setStates(await response.json());
        }
    }

    const loadCity = async (state_ID: number) => {
        const response = await Fetch(`city/dropdown/${state_ID}`, "GET", null, null, null);
        if (response) {
            setCities(await response.json());
        }
    }


    const saveToDB = async (body: IContact) => {
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";
        const response = await Fetch(`Contact_Person${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    const loadSources = async () => {
        const response = await Fetch("source/dropdown", "GET", null, null, null);
        if (response) {
            setSources(await response.json());
        }
    }

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    useEffect(() => {
        loadCountries();
        loadSources();
    }, []);
    // useEffect(() => {
    //     if (countryId) loadStates(countryId);
    //     if (stateId) loadCity(stateId);
    // }, [countryId, stateId]);

    function onSubmit(data: IContact) {
        saveToDB(data);
    }
    useEffect(() => {
        if (countryId) {
            loadStates(countryId);
        } else {
            setStates([]);
        }

        // reset only if not edit mode
        // if (!props.singleData?.id) {
            setValue("state_ID", undefined as any);
            setValue("city_ID", undefined as any);
            setCities([]);
      //  }

    }, [countryId]);

    useEffect(() => {
        if (stateId) {
            loadCity(stateId);
        } else {
            setCities([]);
        }

        if (!props.singleData?.id) {
            setValue("city_ID", undefined as any);
        }

    }, [stateId]);
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Contact" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required label="Contact Person" control={control} name="contact_Person_Name" error={errors.contact_Person_Name?.message} />
                <JVInputMask required label="Contact Number" mask="9999999999" control={control} name="contact_Person_Number" error={errors.contact_Person_Number?.message} />
                <JVInput label="Email" control={control} name="contact_Person_Email" error={errors.contact_Person_Email?.message} />
                <JVDropdown label="Country" control={control} options={countries} optionLabel="country_Name" optionValue="id" name="country_ID" placeholder="Select Country" />
                <JVDropdown label="State" disabled={!countryId} control={control} options={states} optionLabel="state_Name" optionValue="id" name="state_ID" placeholder="Select State" error={errors.state_ID?.message} />
                <JVDropdown label="City" disabled={!stateId} control={control} options={cities} optionLabel="city_Name" optionValue="id" name="city_ID" placeholder="Select City" error={errors.city_ID?.message} />
                <JVDropdown required label="Source" control={control} options={sources} optionLabel="source_Name" optionValue="id" name="source_ID" placeholder="Select Source" error={errors.source_ID?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded p-button-success"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>

                </div>
            </form>
        </Dialog>
    );
}